<template>
  <MatchHeroBanner
    class="match-hero-nav"
    :hero-image="matchHeroData.heroBg"
    :mobile-hero-image="matchHeroData.mobileHeroBg"
    :alt="matchHeroData.alt"
    :nav-bg="matchHeroData.navBg"
    :show-nav-panel="true"
    :show-overlay="true"
    :show-home-button="false"
    :hide-mobile-hero="true"
  >
    <template #nav>
      <div class="nav-content">
        <div class="nav-list">
          <div v-for="item in matchNavList" :key="item.key" class="nav-item"
            :class="[item.theme, { active: activeNavKey === item.key }]" @click="handleNavClick(item)">
            <div class="nav-item-hover"></div>
            <span class="nav-label">{{ item.label }}</span>
            <span class="nav-label-en">{{ item.labelEn }}</span>
          </div>
        </div>

        <div class="cta-button" @click="handleCtaClick">
          <span class="cta-text">{{ matchHeroData.ctaText }}</span>
          <span class="cta-sub">
            {{ matchHeroData.ctaSubText }}
            <img :src="matchHeroData.ctaIcon" :alt="matchHeroData.ctaSubText" />
          </span>
        </div>
      </div>
    </template>
  </MatchHeroBanner>
</template>

<script>
import MatchHeroBanner from '@/components/match/home/MatchHeroBanner.vue'
import { matchHeroData, matchNavList } from '@/data/match/match'

export default {
  name: 'MatchHeroNav',
  components: { MatchHeroBanner },
  data() {
    return {
      matchHeroData,
      matchNavList,
      activeNavKey: (matchNavList.find(item => item.active) || matchNavList[0] || {}).key || '',
    }
  },
  methods: {
    handleNavClick(item) {
      this.activeNavKey = item.key
      if (item.route) {
        this.$router.push({
          path: item.route,
          query: item.anchor ? { anchor: item.anchor } : {},
        })
        return
      }
      if (item.key === 'details') {
        this.$router.push('/match/detail')
        return
      }
      if (item.key === 'benefits') {
        this.$router.push('/match/reward')
        return
      }
      const target = document.getElementById(item.targetId)
      if (!target) return
      const navPanel = document.querySelector('.nav-panel')
      const navHeight = navPanel ? navPanel.offsetHeight : 0
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset - navHeight
      window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' })
    },
    handleCtaClick() {
      this.$router.push('/match/signup')
    },
  },
}
</script>

<style scoped lang="scss">
.match-hero-nav {
  .nav-content {
    position: absolute;
    left: 0.442708rem;
    right: 0.40625rem;
    top: 0.421875rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cta-button {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 0.9375rem;
    height: 0.473958rem;
    padding: 0;
    color: #880208;
    background: transparent;
    border: 0;
    cursor: pointer;
    z-index: 1;

    .cta-text {
      position: relative;
      z-index: 14;
      font-size: 0.234375rem;
      line-height: 0.338542rem;
      font-weight: 700;
      white-space: nowrap;
      margin-top: -0.020833rem;
      transition: text-shadow 0.2s ease, filter 0.2s ease;
    }

    .cta-sub {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      gap: 0.03125rem;
      margin-top: -0.005208rem;
      font-size: 0.09375rem;
      line-height: 1;
      font-weight: 700;
      letter-spacing: 0.010417rem;
      position: relative;
      z-index: 1;
      transition: text-shadow 0.2s ease, filter 0.2s ease;
      display: none;

      img {
        width: 0.307292rem;
        height: auto;
        display: block;
        transition: filter 0.2s ease;
      }
    }

    &:hover .cta-text,
    &:hover .cta-sub {
      text-shadow:
        0 0 0.010417rem rgba(255, 248, 220, 1),
        0 0 0.026042rem rgba(255, 242, 196, 1),
        0 0 0.052083rem rgba(255, 225, 132, 0.95),
        0 0 0.09375rem rgba(255, 204, 82, 0.75),
        0 0 0.145833rem rgba(255, 184, 48, 0.55);
      filter: brightness(1.04);
    }

    &:hover .cta-sub img {
      filter:
        brightness(1.08)
        drop-shadow(0 0 0.010417rem rgba(255, 248, 220, 0.95))
        drop-shadow(0 0 0.036458rem rgba(255, 216, 116, 0.9))
        drop-shadow(0 0 0.072917rem rgba(255, 190, 78, 0.7));
    }
  }

  .nav-list {
    display: grid;
    grid-template-columns: 0.979167rem 0.979167rem 0.979167rem 0.9375rem 0.979167rem 0.979167rem;
    align-items: center;
    width: 5.833333rem;
  }

  .nav-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.010417rem;
    height: 0.5rem;
    color: #e7b57c;
    background: transparent;
    border: 0;
    cursor: pointer;

    .nav-item-hover {
      position: absolute;
      left: 50%;
      top: -0.036458rem;
      width: 0.911458rem;
      height: 0.5rem;

      transform: translateX(-50%);
      z-index: 0;
      pointer-events: none;
      opacity: 0;
      background: url('@/assets/image/match/pc/match/hover.png') center no-repeat;
      background-size: cover;
    }

    &.active .nav-item-hover,
    &:hover .nav-item-hover {
      opacity: 1;
    }

    &.active,
    &:hover {
      color: #ffe1bf;
    }

    span {
      position: relative;
      z-index: 1;
    }

    .nav-label {
      font-size: 0.15625rem;
      line-height: 0.223958rem;
      font-weight: 700;
      text-align: center;
      white-space: nowrap;
      margin-top: -0.010417rem;
    }

    .nav-label-en {
      font-size: 0.072917rem;
      letter-spacing: 0.002604rem;
      text-align: center;
      white-space: nowrap;
      opacity: 0.78;
    }

    &.venue {
      color: #ffffff;
      height: 0.5rem;

      .nav-item-hover {
        display: none;
      }

      &:hover .nav-item-hover {
        display: block;
        opacity: 1;
      }

      &:hover {
        color: #ffe1bf;
      }

      .nav-label {
        font-size: 0.177083rem;
        margin-top: -0.010417rem;
      }

      .nav-label-en {
        color: rgba(150, 150, 150, 0.7);
        opacity: 1;
        margin-top: 0.015625rem;
      }

      &:hover .nav-label-en {
        color: rgba(233, 188, 138, 0.7);
      }
    }

    &.highlight {



      .nav-label {
        color: #ffe1bf;
      }

      .nav-label-en {
        color: rgba(233, 188, 138, 0.7);
        opacity: 1;
      }
    }
  }
  .nav-item+.nav-item {
    padding-left: 0;
  }
}
</style>
